import React from 'react';
import { useModulePublicService } from '../services/module-public-service';

export const useModuleController = () => {
  const { dataPublicModule } = useModulePublicService();
  const [loading, setLoading] = React.useState(false);

  const getSettingsModule = React.useCallback(
    (id) => {
      setLoading(true);
      return dataPublicModule(id)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [dataPublicModule],
  );

  return {
    getSettingsModule,
    loading,
  };
};
